import { Button, Form, Input, Popconfirm, Select, Table } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { apiGetPath, apiPost, apiPutPath } from "../../api/api";
import Modal from "antd/es/modal/Modal";
import { isEmpty } from "../../utils/comm";

const EditableContext = React.createContext(null);
let saveConfirmPop = false;
let delDataSource = [];

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({ title, editable, children, dataIndex, record, handleSave, ...restProps }) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {}
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title}은 필수입력입니다.`,
          },
        ]}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className='editable-cell-value-wrap'
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

const PopManageDevice = ({ children }) => {
  const [dataSource, setDataSource] = useState([]);
  const [zoneList, setZoneList] = useState([]);
  const [formDevice] = Form.useForm();
  const [rowDevId, setRowDevId] = useState();

  const onClickGet = (recode) => {
    setRowDevId(recode.devId);
  };

  const onChangeSelect = (v, v1) => {
    setDataSource(dataSource.map((item) => (item.devId === rowDevId ? { ...item, znId: v, znNm: v1.children } : item)));
  };
  // [SVC-0105024001] 디바이스 구역 드롭박스
  const apiGetZoneList = async () => {
    // const response = await apiGetPath(`Zones/${children.siteId}/${children.svcId}`);
    const response = await apiGetPath(`Zones/list/${children.siteId}`);
    try {
      if (response.code === 0) {
        setZoneList(response.data);
      } else if (response.code === 10) {
        setZoneList([]);
      }
    } catch (error) {}
  };
  // [SVC-0105014007] 디바이스 상태 목록 조회
  const apiGetDeviceList = async () => {
    const response = await apiGetPath(`Device/${children.siteId}/${children.svcId}`);
    try {
      if (response.code === 0) {
        setDataSource(response.data);
      } else if (response.code === 10) {
        setDataSource([]);
      }
    } catch (error) {}
  };

  useEffect(() => {
    delDataSource.length = 0;
    apiGetZoneList();
    apiGetDeviceList();
  }, [children]);

  const onFinishProc = () => {
    onFinish();
    onFinishDelete();
  };

  // [SVC-0105013001] 디바이스 삭제
  const handleDelete = async (recode, index) => {
    const rows = [...dataSource];
    const param = {
      siteId: recode.siteId,
      svcId: recode.svcId,
      devId: recode.devId,
      serialNo: recode.serialNo,
      znId: recode.znId,
      delYn: "Y",
    };

    delDataSource.push(param);

    rows.splice(index, 1);
    setDataSource([...rows]);
  };

  // [SVC-0105012001] 디바이스 구역 변경
  const onFinish = async () => {
    const param = dataSource.map((item) =>
      item !== null
        ? {
            siteId: item.siteId,
            devId: item.devId,
            serialNo: item.serialNo,
            znId: item.znId,
            svcId: item.svcId,
            delYn: "N",
          }
        : undefined
    );
    const response = await apiPutPath(`Device`, param);
    try {
      saveConfirm();
      await apiGetZoneList();
      await apiGetDeviceList();
    } catch (error) {}
  };

  // [SVC- 0105022001] 구역정보 삭제
  const onFinishDelete = async () => {
    if (delDataSource.length == 0) {
      return;
    }

    const response = await apiPutPath(`Device`, delDataSource);
    try {
      if (response.data.code === 0) {
        saveConfirm();
      }
    } catch (error) {}
  };

  function confirm(record, index) {
    Modal.confirm({
      title: "디바이스 삭제",
      icon: null,
      content: "삭제하시겠습니까?",
      okText: "예",
      cancelText: "아니오",
      centered: true,
      onOk: () => handleDelete(record, index),
    });
  }

  function saveConfirm() {
    if (saveConfirmPop) {
      return;
    }

    saveConfirmPop = true;
    Modal.confirm({
      title: "저장 완료",
      icon: null,
      content: "저장이 완료 되었습니다.",
      okText: "확인",
      onOk: () => (saveConfirmPop = false),
      centered: true,
      cancelButtonProps: { style: { display: "none" } },
    });
  }

  const defaultColumns = [
    {
      title: "No",
      dataIndex: "",
      render: (_, record, index) => index + 1,
    },
    {
      title: "시리얼 No",
      dataIndex: "serialNo",
      width: "30%",
      editable: true,
    },
    {
      title: "디바이스 유형",
      dataIndex: "codeNm",
      width: "30%",
    },
    {
      title: "구역",
      dataIndex: "",
      width: "30%",
      render: (_, record) => (
        <Select value={record.znNm} style={{ width: 200 }} onClick={() => onClickGet(record)} onChange={onChangeSelect}>
          {zoneList.map((item, index) => (
            <Select.Option key={index} value={item.znId}>
              {item.znNm}
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: "",
      dataIndex: "",
      render: (_, record, index) =>
        dataSource.length >= 1 ? (
          <Button
            icon={<CloseOutlined />}
            size='small'
            className='btn-ico-del'
            onClick={() => confirm(record, index)}
          />
        ) : null,
    },
  ];

  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.devId === item.devId);
    // const index = newData.findIndex((item) => row.serialNo === item.serialNo);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setDataSource(newData);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    };
  });
  return (
    <div>
      <Form id='formDevice' onFinish={onFinishProc} form={formDevice}>
        <Table
          components={components}
          rowClassName={() => "editable-row"}
          bordered
          dataSource={dataSource}
          columns={columns}
          pagination={false}
        />
      </Form>
    </div>
  );
};

export default PopManageDevice;
